import { ErrorType, LoadedType, RequestType } from 'common/actions/ideasConfiguration';

import requestReducerFactory, { type RequestState } from './requestReducerFactory';
export { defaultState } from './requestReducerFactory';

import type { IdeasConfiguration } from 'common/api/endpoints/idea';

export type IdeasConfigurationState = RequestState<IdeasConfiguration>;

export default requestReducerFactory<IdeasConfiguration>(RequestType, LoadedType, ErrorType);
